import { createFeedbackElement } from './create-feedback-element';

export const mutateFormSubmitButton = (form: HTMLFormElement): HTMLButtonElement | HTMLInputElement => {
    const buttons = form.getElementsByTagName(`button`);
    let button: HTMLButtonElement | HTMLInputElement | undefined = buttons[0];

    if (!button) {
        const submitButton = form.querySelector(`input[type="submit"]`);
        if (submitButton) {
            button = submitButton as HTMLInputElement;
        }

        if (!button) {
            throw new Error(`Missing "button" element.`);
        }
    }

    button.innerHTML = `
        <svg class="h-5 w-5 ml-4 mr-2" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#fff">
            <g fill="none" fill-rule="evenodd">
                <g transform="translate(1 1)" stroke-width="2">
                    <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                    <path d="M36 18c0-9.94-8.06-18-18-18">
                        <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/>
                    </path>
                </g>
            </g>
        </svg>
        ${button.innerHTML}
    `;

    return button;
};

export const mutateForm = async (
    form: HTMLFormElement,
): Promise<{
    button: HTMLButtonElement | HTMLInputElement;
    feedback: HTMLParagraphElement;
    loader: SVGElement;
}> => {
    const button = mutateFormSubmitButton(form);
    const feedback = createFeedbackElement(button);
    const loader = button.querySelector(`svg`) as SVGElement;

    return {
        button,
        feedback,
        loader,
    };
};
